export const RegistrationPageTitle = 'Willing to become a freelancer at Livingston Research?';
export const RegistrationPageSubTitle = 'Let’s get started!';



// WEBPACK FOOTER //
// ./src/custom/livres/RegistrationPageText.js